"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbortableOperation_1 = require("./AbortableOperation");
var HttpRequestDazn_1 = require("./HttpRequestDazn");
var HttpPluginDazn = /** @class */ (function () {
    function HttpPluginDazn(shaka, xhrFactory, httpRequestMonitor, cacheHttpRequests) {
        if (cacheHttpRequests === void 0) { cacheHttpRequests = false; }
        this.shaka = shaka;
        this.xhrFactory = xhrFactory;
        this.httpRequestMonitor = httpRequestMonitor;
        this.cacheHttpRequests = cacheHttpRequests;
        this.httpRequests = [];
        this.counter = 0;
    }
    HttpPluginDazn.prototype.entry = function (uri, request, requestType) {
        var params = {
            uri: uri,
            request: request,
            requestType: requestType
        };
        this.counter += 1;
        var id = this.counter;
        var httpRequest = new HttpRequestDazn_1.default(id, this.xhrFactory(), this.httpRequestMonitor, this.shaka, params);
        var promise = httpRequest.open();
        var abort = function () {
            httpRequest.abort();
            return Promise.resolve();
        };
        if (this.cacheHttpRequests) {
            this.httpRequests.push(httpRequest);
        }
        // return an AbortableOperation
        return new AbortableOperation_1.default(promise, abort);
    };
    HttpPluginDazn.prototype.getHttpRequests = function () {
        return this.httpRequests;
    };
    return HttpPluginDazn;
}());
exports.default = HttpPluginDazn;
//# sourceMappingURL=HttpPluginDazn.js.map